import React from "react";

class MissingPage extends React.Component {

    render() {

        return (
          <div className={"rob-hero rob-hero--404"} style={{backgroundImage: `url(${this.props.url})`}}>
              <h1>404</h1>
              <p>Sorry this page is unavaliable</p>
          </div>
        )
    }
}

MissingPage.defaultProps = {
    url: '',
    title: '',
}

export default MissingPage;




// WEBPACK FOOTER //
// ./src/components/elements/MissingPage.js